/**
 * Кольцевой буфер диагностических логов звонка + pub/sub для UI-панели
 * (см. CallDebugPanel в packages/main). Не связан с console.* — существующие
 * console.debug/console.log в хуках LiveKit трогать не нужно, эти события
 * дублируются сюда точечно, только там, где важно видеть их на экране
 * устройства без доступа к devtools (iPad/iPhone).
 */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var MAX_ENTRIES = 300;
var entries = [];
var nextId = 1;
var listeners = new Set();
function notify() {
    listeners.forEach(function (listener) { return listener(entries); });
}
export function pushCallDebugLog(scope, message, data, level) {
    if (level === void 0) { level = 'info'; }
    var entry = { id: nextId++, time: Date.now(), level: level, scope: scope, message: message, data: data };
    entries = entries.length >= MAX_ENTRIES ? __spreadArray(__spreadArray([], entries.slice(1), true), [entry], false) : __spreadArray(__spreadArray([], entries, true), [entry], false);
    notify();
}
export function subscribeCallDebugLog(listener) {
    listeners.add(listener);
    listener(entries);
    return function () {
        listeners.delete(listener);
    };
}
export function clearCallDebugLog() {
    entries = [];
    notify();
}
export function getCallDebugLogSnapshot() {
    return entries;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FsbERlYnVnTG9nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL3V0aWxzL2NhbGxEZWJ1Z0xvZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7O0dBTUc7Ozs7Ozs7Ozs7QUFjSCxJQUFNLFdBQVcsR0FBRyxHQUFHLENBQUM7QUFFeEIsSUFBSSxPQUFPLEdBQXdCLEVBQUUsQ0FBQztBQUN0QyxJQUFJLE1BQU0sR0FBRyxDQUFDLENBQUM7QUFDZixJQUFNLFNBQVMsR0FBRyxJQUFJLEdBQUcsRUFBMEMsQ0FBQztBQUVwRSxTQUFTLE1BQU07SUFDYixTQUFTLENBQUMsT0FBTyxDQUFDLFVBQUMsUUFBUSxJQUFLLE9BQUEsUUFBUSxDQUFDLE9BQU8sQ0FBQyxFQUFqQixDQUFpQixDQUFDLENBQUM7QUFDckQsQ0FBQztBQUVELE1BQU0sVUFBVSxnQkFBZ0IsQ0FDOUIsS0FBYSxFQUNiLE9BQWUsRUFDZixJQUE4QixFQUM5QixLQUFpQztJQUFqQyxzQkFBQSxFQUFBLGNBQWlDO0lBRWpDLElBQU0sS0FBSyxHQUFzQixFQUFFLEVBQUUsRUFBRSxNQUFNLEVBQUUsRUFBRSxJQUFJLEVBQUUsSUFBSSxDQUFDLEdBQUcsRUFBRSxFQUFFLEtBQUssT0FBQSxFQUFFLEtBQUssT0FBQSxFQUFFLE9BQU8sU0FBQSxFQUFFLElBQUksTUFBQSxFQUFFLENBQUM7SUFDakcsT0FBTyxHQUFHLE9BQU8sQ0FBQyxNQUFNLElBQUksV0FBVyxDQUFDLENBQUMsaUNBQUssT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsVUFBRSxLQUFLLFVBQUUsQ0FBQyxpQ0FBSyxPQUFPLFVBQUUsS0FBSyxTQUFDLENBQUM7SUFDN0YsTUFBTSxFQUFFLENBQUM7QUFDWCxDQUFDO0FBRUQsTUFBTSxVQUFVLHFCQUFxQixDQUFDLFFBQWdEO0lBQ3BGLFNBQVMsQ0FBQyxHQUFHLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDeEIsUUFBUSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQ2xCLE9BQU87UUFDTCxTQUFTLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQzdCLENBQUMsQ0FBQztBQUNKLENBQUM7QUFFRCxNQUFNLFVBQVUsaUJBQWlCO0lBQy9CLE9BQU8sR0FBRyxFQUFFLENBQUM7SUFDYixNQUFNLEVBQUUsQ0FBQztBQUNYLENBQUM7QUFFRCxNQUFNLFVBQVUsdUJBQXVCO0lBQ3JDLE9BQU8sT0FBTyxDQUFDO0FBQ2pCLENBQUMifQ==